import ParametricArchitecture from "./ParametricArchitecture";

const REGISTRY = {
  ParametricArchitecture: () => Promise.resolve({ default: ParametricArchitecture }),
  Claude2: () => import("./Claude2"),
  Claude35Haiku: () => import("./Claude35Haiku"),
  Claude3Haiku: () => import("./Claude3Haiku"),
  Claude3Opus: () => import("./Claude3Opus"),
  Claude3Sonnet: () => import("./Claude3Sonnet"),
  CodeLlamaBaseArchitecture: () => import("./CodeLlamaBaseArchitecture"),
  CodeQwenArchitecture: () => import("./CodeQwenArchitecture"),
  CodexArchitecture: () => import("./CodexArchitecture"),
  Dalle2Architecture: () => import("./Dalle2Architecture"),
  Dalle3Architecture: () => import("./Dalle3Architecture"),
  "DeepSeek-R1": () => import("./DeepSeek-R1"),
  "DeepSeek-V3": () => import("./DeepSeek-V3"),
  DeepSeekCoderV2Architecture: () => import("./DeepSeekCoderV2Architecture"),
  EmbeddingModelsArchitecture: () => import("./EmbeddingModelsArchitecture"),
  Falcon180BArchitecture: () => import("./Falcon180BArchitecture"),
  Falcon2_11BArchitecture: () => import("./Falcon2_11BArchitecture"),
  Falcon2_11B_VLMArchitecture: () => import("./Falcon2_11B_VLMArchitecture"),
  Falcon3_10B_BaseArchitecture: () => import("./Falcon3_10B_BaseArchitecture"),
  Falcon3_1B_BaseArchitecture: () => import("./Falcon3_1B_BaseArchitecture"),
  Falcon3_3B_BaseArchitecture: () => import("./Falcon3_3B_BaseArchitecture"),
  Falcon3_7B_BaseArchitecture: () => import("./Falcon3_7B_BaseArchitecture"),
  Falcon3_Mamba_7BArchitecture: () => import("./Falcon3_Mamba_7BArchitecture"),
  Falcon40BArchitecture: () => import("./Falcon40BArchitecture"),
  Falcon7BArchitecture: () => import("./Falcon7BArchitecture"),
  "GPT-1": () => import("./GPT-1"),
  "GPT-2": () => import("./GPT-2"),
  "GPT-3.5": () => import("./GPT-3.5"),
  "GPT-3": () => import("./GPT-3"),
  "GPT-4Architecture": () => import("./GPT-4Architecture"),
  "GPT-4o": () => import("./GPT-4o"),
  "GPT-o1-mini": () => import("./GPT-o1-mini"),
  "GPT-o1-preview": () => import("./GPT-o1-preview"),
  Gemini: () => import("./Gemini"),
  Gemini15Architecture: () => import("./Gemini15Architecture"),
  GeminiBaseArchitecture: () => import("./GeminiBaseArchitecture"),
  GeminiNano1Architecture: () => import("./GeminiNano1Architecture"),
  GeminiNano2Architecture: () => import("./GeminiNano2Architecture"),
  GeminiUltraArchitecture: () => import("./GeminiUltraArchitecture"),
  JanusProArchitecture: () => import("./JanusProArchitecture"),
  Lamda: () => import("./Lamda"),
  Llama: () => import("./Llama"),
  Llama2: () => import("./Llama2"),
  LlamaInstructArchitecture: () => import("./LlamaInstructArchitecture"),
  LlamaPythonArchitecture: () => import("./LlamaPythonArchitecture"),
  MathQwenArchitecture: () => import("./MathQwenArchitecture"),
  Qwen: () => import("./Qwen"),
  QwenBaseArchitecture: () => import("./QwenBaseArchitecture"),
  QwenChatArchitecture: () => import("./QwenChatArchitecture"),
  SoraArchitecture: () => import("./SoraArchitecture"),
  WhisperArchitecture: () => import("./WhisperArchitecture"),
};

const cache = new Map();

export function resolveDiagramKey(modelOrName) {
  let name = "";
  let mId = "";

  if (typeof modelOrName === "string") {
    name = modelOrName.toLowerCase();
    mId = modelOrName.toLowerCase();
  } else if (modelOrName && typeof modelOrName === "object") {
    name = (modelOrName.name || "").toLowerCase();
    mId = (modelOrName.id || "").toLowerCase();
  }

  // Exact & pattern heuristics for flagship models
  if (name.includes("gpt-4o") || mId.includes("gpt-4o")) return "GPT-4o";
  if (name.includes("o1-mini") || mId.includes("o1-mini")) return "GPT-o1-mini";
  if (
    name.includes("o1") ||
    mId.includes("o1") ||
    name.includes("o3") ||
    mId.includes("o3") ||
    name.includes("gpt-5") ||
    mId.includes("gpt-5")
  )
    return "GPT-o1-preview";
  if (name.includes("gpt-4") || mId.includes("gpt-4")) return "GPT-4Architecture";
  if (name.includes("gpt-3.5") || mId.includes("gpt-3.5")) return "GPT-3.5";
  if (name.includes("gpt-3") || mId.includes("gpt-3")) return "GPT-3";
  if (name.includes("gpt-2") || mId.includes("gpt-2")) return "GPT-2";
  if (name.includes("gpt-1") || mId.includes("gpt-1")) return "GPT-1";

  if (name.includes("opus") || mId.includes("opus")) return "Claude3Opus";
  if (name.includes("haiku") || mId.includes("haiku"))
    return name.includes("3.5") || mId.includes("3.5") || name.includes("4")
      ? "Claude35Haiku"
      : "Claude3Haiku";
  if (
    name.includes("sonnet") ||
    mId.includes("sonnet") ||
    name.includes("claude") ||
    mId.includes("claude")
  )
    return "Claude3Sonnet";
  if (name.includes("claude-2") || mId.includes("claude-2")) return "Claude2";

  if (name.includes("deepseek") || mId.includes("deepseek")) {
    if (name.includes("r1") || mId.includes("r1")) return "DeepSeek-R1";
    if (name.includes("coder") || mId.includes("coder"))
      return "DeepSeekCoderV2Architecture";
    return "DeepSeek-V3";
  }

  if (name.includes("gemini") || mId.includes("gemini")) {
    if (name.includes("nano") || mId.includes("nano")) return "GeminiNano1Architecture";
    if (name.includes("ultra") || mId.includes("ultra")) return "GeminiUltraArchitecture";
    if (
      name.includes("1.5") ||
      mId.includes("1.5") ||
      name.includes("2.5") ||
      mId.includes("2.5")
    )
      return "Gemini15Architecture";
    return "Gemini";
  }

  if (name.includes("gemma") || mId.includes("gemma")) return "GeminiBaseArchitecture";

  if (name.includes("llama") || mId.includes("llama")) {
    if (name.includes("guard") || mId.includes("guard") || name.includes("instruct"))
      return "LlamaInstructArchitecture";
    if (name.includes("2") || mId.includes("2")) return "Llama2";
    return "Llama";
  }

  if (name.includes("qwen") || mId.includes("qwen")) {
    if (name.includes("coder") || mId.includes("coder")) return "CodeQwenArchitecture";
    if (name.includes("math") || mId.includes("math")) return "MathQwenArchitecture";
    if (name.includes("chat") || mId.includes("chat")) return "QwenChatArchitecture";
    return "Qwen";
  }

  if (name.includes("falcon") || mId.includes("falcon")) {
    if (name.includes("mamba") || mId.includes("mamba")) return "Falcon3_Mamba_7BArchitecture";
    if (name.includes("10b") || mId.includes("10b")) return "Falcon3_10B_BaseArchitecture";
    if (name.includes("1b") || mId.includes("1b")) return "Falcon3_1B_BaseArchitecture";
    if (name.includes("3b") || mId.includes("3b")) return "Falcon3_3B_BaseArchitecture";
    if (name.includes("7b") || mId.includes("7b")) return "Falcon3_7B_BaseArchitecture";
    if (name.includes("180b") || mId.includes("180b")) return "Falcon180BArchitecture";
    if (name.includes("40b") || mId.includes("40b")) return "Falcon40BArchitecture";
    return "Falcon7BArchitecture";
  }

  if (name.includes("janus") || mId.includes("janus")) return "JanusProArchitecture";
  if (name.includes("dall") || mId.includes("dall")) return "Dalle3Architecture";
  if (name.includes("sora") || mId.includes("sora")) return "SoraArchitecture";
  if (name.includes("whisper") || mId.includes("whisper")) return "WhisperArchitecture";
  if (name.includes("embed") || mId.includes("embed")) return "EmbeddingModelsArchitecture";

  // Fallback to ParametricArchitecture for any other model
  return "ParametricArchitecture";
}

export default async function getDiagramComponent(modelOrName) {
  const key = resolveDiagramKey(modelOrName);
  if (cache.has(key)) return cache.get(key);

  const loader = REGISTRY[key];
  if (!loader) {
    // If not found in registry, default to ParametricArchitecture
    cache.set(key, ParametricArchitecture);
    return ParametricArchitecture;
  }

  try {
    const mod = await loader();
    const comp = mod.default || mod[Object.keys(mod)[0]];
    cache.set(key, comp || ParametricArchitecture);
    return comp || ParametricArchitecture;
  } catch (e) {
    if (process.env.NODE_ENV !== "production") {
      console.warn(`Diagram load failed for key ${key}:`, e?.message);
    }
    cache.set(key, ParametricArchitecture);
    return ParametricArchitecture;
  }
}